// FourthPhase Scripts
document.addEventListener("DOMContentLoaded", () => {
  try {
    // ******* BCFM Nav Link Color Change Script *******
    const fpTaggedNavLinks = document.querySelectorAll('.fp-navlink-tag');
    
    if (fpTaggedNavLinks.length > 0) {
      // Loop through every nav link and check if the value is in BCFM range
      var navLinks = [...fpTaggedNavLinks]

      navLinks.forEach(navLink => {
        // 70% off
        if (navLink.textContent.includes("70%")) {
          navLink.classList.add("fp-bcfm-red")
        }

        // 50% off
        if (navLink.textContent.includes("50%")) {
          navLink.classList.add("fp-bcfm-orange")
        }

        // 20% off
        if (navLink.textContent.includes("20%")) {
          navLink.classList.add("fp-bcfm-yellow")
        }
      })
    }
  } catch (error) {
    return;
  }
});
